import _regeneratorRuntime from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toArray from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import $ from 'jquery';
/* eslint-disable no-unused-vars, no-undef */

var loadPath = function loadPath(lngs, namespaces) {
  var hash = JSON_HASHES["".concat(namespaces, ".json")];

  if (lngs === 'en-us') {
    return "".concat(LOCALES_PATH, "json/{{- ns}}.json?v=").concat(hash);
  }

  return "".concat(LOCALES_PATH, "{{lng}}/json/{{- ns}}.json?v=").concat(hash);
};
/* eslint-enable no-unused-vars, no-undef */

/**
 * AppLoader
 *
 * Allows multiple apps that need i18n to be loaded on a page
 * at once. All content in namepaces must be accessed with namespace
 * prefix `i18next.t('mynamespace:button.save');`
*/


var AppLoader = /*#__PURE__*/function () {
  function AppLoader() {
    _classCallCheck(this, AppLoader);

    this.apps = new Set();
    this.namespaces = new Set();
  } // register an app


  _createClass(AppLoader, [{
    key: "register",
    value: function register(app) {
      var _this = this;

      this.apps.add(app); // no namespaces, assume namespace is the same as the app name

      for (var _len = arguments.length, namespaces = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        namespaces[_key - 1] = arguments[_key];
      }

      if (!namespaces.length) {
        namespaces.push(app);
      }

      namespaces.forEach(function (namespace) {
        return _this.namespaces.add(namespace);
      });
    } // load all of the registered apps
    // TODO: Better error handling and some sort of load early/load late mechanism
    // options = config options for i18next, overrides above `i18nextOptions`
    //           https://www.i18next.com/overview/configuration-options

  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options,
            apps,
            _yield$Promise$all,
            _yield$Promise$all2,
            i18n,
            modules,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.prev = 1;
                apps = _toConsumableArray(this.apps);
                _context.next = 5;
                return Promise.all([import(
                /* webpackChunkName: "i18n" */
                '@cigna/cigna_digital_dcws_cigna-frontend/src/js/i18n')].concat(_toConsumableArray(apps.map(function (name) {
                  return import(
                  /* webpackChunkName: "[request]" */
                  "./".concat(name));
                }))));

              case 5:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _toArray(_yield$Promise$all);
                i18n = _yield$Promise$all2[0];
                modules = _yield$Promise$all2.slice(1);
                _context.next = 11;
                return i18n.default(_objectSpread({
                  ns: _toConsumableArray(this.namespaces)
                }, options));

              case 11:
                modules.forEach(function (module) {
                  return module.default(i18n.i18next);
                }); // eslint-disable-next-line no-undef

                if (MODE === 'development') {
                  window.i18next = i18n.i18next;
                }

                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](1);
                console.log('An error occurred while loading apps', _context.t0);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 15]]);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }]);

  return AppLoader;
}();

var loadApps = function loadApps() {
  var loader = new AppLoader();

  if ($('[data-ifp-plans-single]').length || $('[data-ifp-plans-landing]').length) {
    loader.register('ifp-plans-single', 'ifp-state-2023');
  }

  if ($('[data-countdown-show]').length) {
    loader.register('countdown');
  }

  loader.load({
    fallbackLng: 'en-us',
    backend: {
      loadPath: loadPath
    }
  });
};

var loadHealthEngAssessment = function loadHealthEngAssessment() {
  if ($('[data-health-eng-assessment]').length) {
    import(
    /* webpackChunkName: "health-eng-assessment" */
    './health-eng-assessment').then(function (module) {
      return module.default();
    }) // eslint-disable-next-line no-unused-vars
    .catch(function (error) {
      return 'An error occurred while loading the assessment';
    });
  }
};

export default (function () {
  loadHealthEngAssessment();
  loadApps();
});